import React from 'react';
import { MARKET_MARGINS_MODAL_TYPES } from '../../../constants';

const MarginModalToggleSection = ({
  toggleDropdown, modalType, dropdownOpen, getMarketName, availableMarkets, selectMarket,
}) => (
  <div className="dialog__row m-b-20 p-r-60">
    <div
      className="dialog__input-wrap"
      onClick={toggleDropdown}
      disabled={modalType === MARKET_MARGINS_MODAL_TYPES.EDIT}
    >
      <label className="dialog__input-label dialog__input-label--cut">Market</label>
      <div className={`dialog__input dialog__input--select ${dropdownOpen ? 'open' : ''}`}>
        <span className="txt">{getMarketName()}</span>
      </div>
      <div className="dialog__input-dropdown">
        <div className="dialog__input-list">
          {availableMarkets?.map((market) => (
            <div
              className="dialog__input-list-item"
              key={`market-${market?.id}`}
              onClick={selectMarket.bind(this, market?.id)}
            >
              {market?.name}
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default MarginModalToggleSection;
